var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from 'react';
import SamplesUtil from '../../utils/samplesUtil';
import Icons from '../Icons/Icons';
const handleize = (string) => {
    return string.replace(/[^a-z0-9]+/gi, '-').toLowerCase();
};
const calculateAllowedSamples = (cartItems, samples) => {
    var _a;
    let totalSamples = 0;
    for (const item of cartItems) {
        const sample = samples.find((s) => s.current_variant.id == item.variant_id);
        if (!!sample)
            continue;
        const receiveComplimentary = ((_a = item.metafields) === null || _a === void 0 ? void 0 : _a.receive_complimentary) || 0;
        totalSamples += receiveComplimentary * item.quantity;
    }
    return Math.min(totalSamples, 6);
};
const ComplimentarySamplesNew = ({ cartItems, updateVariants, updateSamples, loadingSamples, settings, hideCounterBeforeLoad = false }) => {
    const [samples, setSamples] = useState([]);
    const [accordionExpanded, setAccordionExpanded] = useState(true);
    const [updatingSample, setUpdatingSample] = useState(false);
    const updateVariantsWrapper = (variants, quantity) => __awaiter(void 0, void 0, void 0, function* () {
        let newCart = yield updateVariants(variants, quantity);
        return newCart;
    });
    useEffect(() => {
        const fetchSamples = () => __awaiter(void 0, void 0, void 0, function* () {
            const samples = yield SamplesUtil.getSampleProducts('active-samples');
            setSamples(samples);
            updateSamples(samples);
        });
        fetchSamples();
    }, []);
    const handleSelectSample = (selectedSample, e) => __awaiter(void 0, void 0, void 0, function* () {
        e.preventDefault();
        e.stopPropagation();
        setUpdatingSample(selectedSample.id);
        const sample = samples.find((s) => s.id === selectedSample.id);
        if (!sample)
            return;
        yield updateVariantsWrapper([sample.variants[0].id], 1);
        setTimeout(() => {
            setUpdatingSample(false);
        }, 100);
    });
    const handleRemoveSample = (sample, e) => __awaiter(void 0, void 0, void 0, function* () {
        e.preventDefault();
        e.stopPropagation();
        setUpdatingSample(sample.id);
        const variantId = (sample.variants || [])[0].id;
        yield updateVariantsWrapper([variantId], 0);
        setTimeout(() => {
            setUpdatingSample(false);
        }, 100);
    });
    const cartItemsLatest = cartItems || [];
    const samplesInCart = cartItemsLatest.filter((item) => samples.some((sample) => sample.current_variant.id == item.variant_id));
    const allowedSamples = calculateAllowedSamples(cartItemsLatest, samples);
    const selectedCount = samplesInCart.length;
    if (cartItems.length === 0 || allowedSamples === 0) {
        return React.createElement(React.Fragment, null); // No samples to display if cart is empty or no allowed samples
    }
    return (React.createElement("div", { className: "sidecart-samples" },
        React.createElement("h3", { className: "sidecart-samples__title" }, settings === null || settings === void 0 ? void 0 :
            settings.samplesTitle,
            !!hideCounterBeforeLoad && samples.length === 0 ? React.createElement(React.Fragment, null) : (React.createElement("div", { className: "sidecart-samples__counter" },
                loadingSamples ?
                    React.createElement("span", { style: { visibility: 'hidden' } },
                        selectedCount,
                        " / ",
                        allowedSamples) :
                    React.createElement("span", null,
                        selectedCount,
                        " / ",
                        allowedSamples),
                " selected",
                loadingSamples ? React.createElement(Icons.Loading, null) : '')),
            React.createElement("button", { className: "sidecart-samples__accordion-toggle", onClick: () => setAccordionExpanded(!accordionExpanded) }, accordionExpanded ? React.createElement(Icons.Minus, null) : React.createElement(Icons.Plus, null))),
        React.createElement("span", { className: "sidecart-samples__subtitle" }, settings === null || settings === void 0 ? void 0 : settings.samplesSubtitle),
        React.createElement("div", { className: `sidecart-samples__accordion ${accordionExpanded ? 'sidecart-samples__accordion--expanded' : ''}` },
            React.createElement("div", { className: "sidecart-samples__list" }, samples.map((sample, index) => {
                const variantId = (sample.variants || [])[0].id;
                const sampleSelected = cartItemsLatest.find((item) => item.variant_id == variantId);
                const disabled = selectedCount >= allowedSamples && !sampleSelected;
                const sampleTag = `sample-${handleize(sample.title)}`;
                return (React.createElement("div", { className: "sidecart-samples__item", key: index, "data-disabled": disabled, "data-selected": !!sampleSelected },
                    sampleSelected && (React.createElement("div", { className: "sidecart-samples__item-ticked" },
                        React.createElement(Icons.Tick, null))),
                    disabled && (React.createElement("div", { className: "sidecart-samples__item-disabled" },
                        React.createElement(Icons.Padlock, null))),
                    React.createElement("div", { className: "sidecart-samples__item-image-container" },
                        React.createElement("img", { className: "sidecart-samples__item-image", src: sample.featured_image.url, alt: sample.featured_image.alt })),
                    React.createElement("div", { className: "sidecart-samples__item-title" }, sample.title),
                    updatingSample === sample.id ? (React.createElement("div", { className: "sidecart-samples__item--loading" },
                        React.createElement(Icons.Loading, null))) : sampleSelected ? (React.createElement("a", { id: sampleTag, className: "sidecart-samples__item-select", onClick: (e) => handleRemoveSample(sample, e) }, "Remove")) : (React.createElement("a", { id: sampleTag, className: `sidecart-samples__item-select${disabled ? ' sidecart-samples__item-select--disabled' : ''}`, onClick: (e) => handleSelectSample(sample, e) }, "Add"))));
            })))));
};
export default ComplimentarySamplesNew;
